import type { IconProps } from './IconProps';

export const ChartCandleIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path d="M5 2V4M5 12V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="3.25" y="4" width="3.5" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <path d="M11 3V5.5M11 10.5V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="9.25" y="5.5" width="3.5" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
